export default __webpack_public_path__ + "static/media/hu.0ea3b75a.svg";